import angular from 'angular'

import { isEmpty } from '../utils/bits'
import { isFunction } from 'lodash-es'

import setCss from '../utils/set-css'
import extractRawElm from '../utils/extract-raw-elm'

angular
  .module('ggs.img-queue')
  .directive('ggsImgQueue', ImgQueueDirective)

const IMG_TAG_NAME = 'IMG'
const BACKGROUND_IMAGE_CSS_KEY = 'backgroundImage'

const BACKGROUND_URL_PREFIX = 'url("'
const BACKGROUND_URL_SUFFIX = '")'

const FAIL_SIGN = 'fail'
const DONE_SIGN = 'done'
const SIGN_ATTR_NAME = 'ggs-img-queue-sign'

function ImgQueueDirective(qh, applyAsync, imgQueueInternal) {

  function realLink($scope, $elm, $attr) {
    const src = $scope.$eval($attr.ggsImgQueueSrc)
    const events = $scope.$eval($attr.ggsImgQueueEvents)
    const runImmediately = $scope.$eval($attr.ggsImgQueueRunImmediately)

    const doneOrig = events.done
    const failOrig = events.fail
    const eventsWrap = { done: doneWrap, fail: failWrap }

    const elm = extractRawElm($elm)
    const target = elm.tagName === IMG_TAG_NAME ? elm : null

    const reg = {
      src,
      err: null,
      size: null,
      target,
      events: eventsWrap,
      isKilled: false,
      isProcessed: false,
      isProcessing: false,
      myImageLoader: null
    }

    $scope.$on('$destroy', onDestroy)

    !runImmediately
      ? imgQueueInternal.stayInQueue(reg)
      : imgQueueInternal.runImmediately(reg)

    function doneWrap(size) {
      elm.setAttribute(SIGN_ATTR_NAME, DONE_SIGN)

      if (elm.tagName === IMG_TAG_NAME) {
        if (isEmpty(elm.src)) {
          elm.src = src
        }
      } else {
        const url = BACKGROUND_URL_PREFIX + src + BACKGROUND_URL_SUFFIX
        setCss(elm, BACKGROUND_IMAGE_CSS_KEY, url)
      }

      if (isFunction(doneOrig)) {
        applyAsync($scope, doneOrig, size)
      }
    }

    function failWrap(err) {
      if (qh.isCanceled(err)) {
        return
      }

      const elm = extractRawElm($elm)
      elm.setAttribute(SIGN_ATTR_NAME, FAIL_SIGN)

      if (isFunction(failOrig)) {
        applyAsync($scope, failOrig, err)
      }
    }

    function onDestroy() {
      imgQueueInternal.killReg(reg)
    }
  }

  return {
    restrict: 'A',
    link: realLink
  }
}
